import { ReactNode } from 'react';
import { Inbox, type LucideIcon } from 'lucide-react';
import { cn } from '../../lib/cn';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** Clear "nothing here yet / nothing matches" block, with an optional next step. */
export function EmptyState({ icon: Icon = Inbox, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2 px-4 py-10 text-center', className)}>
      <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-surface-sunken text-text-tertiary">
        <Icon size={22} />
      </div>
      <p className="font-display text-[15px] font-bold text-text-primary">{title}</p>
      {description && <div className="max-w-[460px] text-sm text-text-secondary">{description}</div>}
      {action && <div className="mt-2 flex flex-wrap justify-center gap-2">{action}</div>}
    </div>
  );
}
